import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MissingDataSectionNotifierService {
   missingDataSubject = new BehaviorSubject<boolean>(true);

  isMissingDataPushNotification(isMissingData:boolean){
    this.missingDataSubject.next(isMissingData);
  }
  isMissingDataRecieveNotification():Observable<boolean>{
    return this.missingDataSubject;
  }
}
